import React, { useState, useCallback, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { main } from "../../store/slices";
import { get } from "lodash";
import { useNavigate } from "react-router-dom";
import { ErrorModal } from "../../components/Modal";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { Input, Form, Typography, Button } from "antd";
import { User, Lock } from "lucide-react";
import { motion } from "framer-motion";
import Stars from "../../components/LoginStars/index";

const Login = () => {
	const { t } = useTranslation();
	const {
		setMe,
		setCollapse,
		setSelectedPath,
		setOpenMiniMenu,
		setLoginUser,
		setFirstName,
		setLastName,
		setJobtitle,
	} = main.actions;

	const { loginUser } = useSelector((state) => state.main);
	const loginValue = get(loginUser, "login", "");
	const passwordValue = get(loginUser, "password", "");

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [login, setLogin] = useState(loginValue);
	const [password, setPassword] = useState(passwordValue);
	const [isLoading, setIsLoading] = useState(false);

	const [form] = Form.useForm();

	const errorRef = useRef();
	const getErrorRef = useCallback((ref) => {
		errorRef.current = ref;
	}, []);

	useEffect(() => {
		form.setFieldsValue({
			login: loginValue,
			password: passwordValue,
		});
	}, [loginValue, passwordValue]);

	const loginProfile = () => {
		setIsLoading(true);

		axios
			.get(
				`https://rofood-dashboard-backend.bis-apps.com/api/auth?EmployeeCode=${login}&ExternalEmployeeNumber=${password}`
			)
			.then((res) => {
				axios.defaults.headers.common["Authorization"] = `Bearer ${get(
					res,
					"data.accessToken",
					""
				)}`;
				console.log(res.data);

				dispatch(setCollapse(false));
				dispatch(setSelectedPath("dashboard"));
				dispatch(setOpenMiniMenu(["dashboard"]));
				dispatch(
					setLoginUser({
						login,
						password,
					})
				);

				let aaa = {
					firstName: get(res, "data.firstName", ""),
					lastName: get(res, "data.lastName", ""),
					token: get(res, "data.accessToken", ""),
					jobTitle: get(res, "data.jobTitle", ""),
				};
				dispatch(setFirstName(get(res, "data.firstName", "")));
				dispatch(setLastName(get(res, "data.lastName", "")));
				dispatch(setJobtitle(get(res, "data.jobTitle", "")));

				dispatch(setMe(aaa));
				dispatch(setMe(aaa));
				dispatch(setMe(aaa));

				dispatch(setMe(aaa));
				localStorage.setItem("token", get(res, "data.accessToken", ""));
				localStorage.setItem("selectedMenu", "dashboardRoFood");
				navigate("/dashboardRoFood");
				setIsLoading(false);
			})
			.catch((err) => {
				setIsLoading(false);
				console.log(err);
				errorRef.current?.open("Ошибка логина или пароля");
			});
	};

	return (
		<div className="relative flex h-screen w-full flex-col items-center justify-center overflow-hidden bg-gradient-to-l from-basic  to-[#1c1b1b] bg-[length:200%_200%]">
			<Stars />

			<motion.div
				initial={{ opacity: 0, y: -20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8, ease: "easeOut" }}
				className="flex w-[400px] items-center justify-center rounded-xl bg-white/90 shadow-2xl backdrop-blur-sm"
			>
				<Form form={form} onFinish={loginProfile} className="flex w-full flex-col items-center p-8">
					<div className="mb-6 flex flex-col items-center gap-2">
						<Typography.Title
							level={2}
							className="font-montserrat text-3xl font-semibold !text-basic"
						>
							Login
						</Typography.Title>
					</div>

					<Form.Item
						name="login"
						rules={[{ required: true, message: "Foydalanuvchi nomi kiritilmadi!" }]}
						className="w-full"
					>
						<div className="flex flex-col gap-2">
							<label htmlFor="login" className="font-montserrat text-base font-medium text-basic">
								User
							</label>
							<Input
								id="login"
								value={login}
								onChange={(e) => setLogin(e.target.value)}
								prefix={<User color="gray" size={20} />}
								placeholder={"Foydalanuvchi nomini kiritng"}
								autoFocus
								className="h-10 w-full"
							/>
						</div>
					</Form.Item>

					<Form.Item
						name="password"
						rules={[{ required: true, message: "Parol kiritilmadi!" }]}
						className="w-full"
					>
						<div className="mt-2 flex flex-col gap-2">
							<label
								htmlFor="password"
								className="font-montserrat text-base font-medium text-basic"
							>
								Parol
							</label>
							<Input.Password
								id="password"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								placeholder={"Parolni kiriting"}
								prefix={<Lock color="gray" size={20} className="mr-1" />}
								className="h-10 w-full"
							/>
						</div>
					</Form.Item>

					<div className="mt-6 w-full">
						<Button
							type="default"
							htmlType="submit"
							loading={isLoading}
							className="font-montserrat h-10 w-full bg-gradient-to-br from-[#23acc1] to-[#0A4D68] text-base font-bold text-white hover:!border-[#23acc1] hover:!bg-gradient-to-r hover:!from-[#0A4D68] hover:!to-[#23acc1] hover:!text-white"
						>
							Kirish
						</Button>
					</div>
				</Form>
			</motion.div>

			<motion.div
				initial={{ opacity: 0, y: 20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8, ease: "easeOut" }}
				className="absolute bottom-10 py-2 text-center text-sm"
			>
				<footer className="animate-gradient bg-inherit bg-gradient-to-l from-[#23acc1] to-[#0A4D68] bg-clip-text text-transparent">
					Business Intelligence Solutions® 2025
				</footer>
			</motion.div>

			<motion.div
				initial={{ opacity: 0, y: 20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
			>
				<ErrorModal getRef={getErrorRef} title={t("Ошибка логина или пароля, проверьте еще раз")} />
			</motion.div>
		</div>
	);
};

export default Login;
